import WebGLSketch from "../_app/cuchillo/3D/WebGLSketch";
import Image from "../_app/cuchillo/3D/Image";
import Plane from "../_app/cuchillo/3D/Plane";
import { GetBy } from "../_app/cuchillo/core/Element";
import Box from "./Box";
import { ControllerPage } from "../_app/cuchillo/pages/ControllerPage";
import Text3D from "../_app/cuchillo/3D/Text3D";

export default class BoxProject extends Box {
  constructor(__dom) {
    super(__dom);

    const sec = GetBy.selector('[data-image-secondary]', __dom)[0];
    if (sec) {
      const secondary3D = new Image({
        dom: sec,
        size: {
          y: parseInt(sec.dataset.height),
          x: parseInt(sec.dataset.width)
        }
      });

      this.add(secondary3D);
      this.items.push(secondary3D);
    }

    const plane = GetBy.selector('[data-bg]', __dom)[0];
    const plane3D = new Plane({
      dom: plane,
      size: {
        y: parseInt(plane.dataset.height),
        x: parseInt(plane.dataset.width)
      }
    });

    this.add(plane3D);
    this.items.push(plane3D);

    const link = GetBy.selector('[data-link]', __dom)[0];
    const link3D = new Image({
      dom: link,
      size: {
        y: parseInt(link.dataset.height),
        x: parseInt(link.dataset.width)
      }
    });
    link3D.mesh.userData.isClickable = true;
    link3D.mesh.userData.link = link.href;
    link3D.mesh.userData.onClick = () => {
      console.log('Link Clicked');
      ControllerPage.changePage(link3D.mesh.userData.link);
    };

    this.add(link3D);
    this.items.push(link3D);
    WebGLSketch.addInteractive(link3D.mesh);

    const name = GetBy.selector('[data-name]', __dom)[0];
    const name3D = new Text3D({ dom: name, text: name.dataset.name });
    this.add(name3D);
    this.items.push(name3D);

    // La imatge primària navega al projecte, igual que el botó [data-info]
    const info = GetBy.selector('[data-info]', __dom)[0];
    if (this.primary && info) {
      this.primary.mesh.userData.isClickable = true;
      this.primary.mesh.userData.link = info.href;
      this.primary.mesh.userData.onClick = () => {
        ControllerPage.changePage(this.primary.mesh.userData.link);
      };

      // La primària no té imatge de hover (data-src-hover); apuntem texture2 a
      // texture1 perquè el flag 'hover' del raycaster no la enfosqueixi.
      this.primary.material.uniforms.texture2 = this.primary.material.uniforms.texture1;

      WebGLSketch.addInteractive(this.primary.mesh);
    }
  }
}
